import axios from 'axios';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

axios.defaults.baseURL = process.env.VUE_APP_CORNERSTONE_WORDPRESS_API_BASE_URL;

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
